import React from "react";
import { p2pIsLiveFixture, p2pNeedsOutcome } from "../../users/userP2PHelpers";
import P2PFixtureBlock from "./P2PFixtureBlock";
import P2PLedgerBacking from "./P2PLedgerBacking";

function duelHeat(duel, maxPool) {
  if (duel.status === "Active" && duel.p2pStatus === "Pending") return 100;
  const pool = Number(duel.poolTotal) || 0;
  if (!maxPool) return 12;
  return Math.max(8, Math.round((pool / maxPool) * 100));
}

export default function P2PFloorRow({ duel, rank, selected, onSelect, heatPct }) {
  const needsOutcome = p2pNeedsOutcome(duel);
  const live = p2pIsLiveFixture(duel);

  return (
    <button
      type="button"
      className={`amf-row ap2p-row ${selected ? "amf-row-selected" : ""} ${needsOutcome ? "amf-row-action" : ""} ${live ? "ap2p-row-live" : ""}`}
      aria-pressed={selected}
      onClick={onSelect}
    >
      <span
        className="amf-row-heat"
        style={{ "--heat": `${heatPct}%` }}
        title={needsOutcome ? "Awaiting outcome" : "Pool size"}
        aria-hidden
      />
      <span className="amf-row-rank">{String(rank).padStart(2, "0")}</span>
      <span className="amf-row-body ap2p-row-body">
        <P2PFixtureBlock duel={duel} compact logoSize={22} className="ap2p-row-fixture" />
        <P2PLedgerBacking selection={duel.selection} />
      </span>
    </button>
  );
}

export { duelHeat };
